export const env = "prod";
export const sendemailnsms = "https://lg6qtrhsf5.execute-api.ap-south-1.amazonaws.com/sendemailnsms";
export const otpMobileSendDev = "https://jtb1gx7p8l.execute-api.ap-south-1.amazonaws.com/otpMobileSendDev";
export const sendparentalconsent = "https://ceropnoge3.execute-api.ap-south-1.amazonaws.com/sendparentalconsent";
export const otpvarify = "https://zi1lq4olk9.execute-api.ap-south-1.amazonaws.com/otpvarify";
export const getparentalconsent = "https://8x0l6n4tca.execute-api.ap-south-1.amazonaws.com/getparental_consent";
export const getUserProfileImage = "https://888rmx56ng.execute-api.ap-south-1.amazonaws.com/default/getUserProfileImage";
export const welcomeemail= "https://vv4pst9ox7.execute-api.ap-south-1.amazonaws.com/welcomeemail";
export const selfemailverification="https://0xx9mfwfqk.execute-api.ap-south-1.amazonaws.com/selfemailverification";
export const mbileverificationreminder ="https://hwalxgciig.execute-api.ap-south-1.amazonaws.com/mbileverificationreminder";
export const userinvitation="https://t5imomhhbi.execute-api.ap-south-1.amazonaws.com/userinvitation/";
export const smarttech = "https://ddedwz07tc.execute-api.ap-south-1.amazonaws.com/smarttehuser/";
export const notification="https://nlerubfldd.execute-api.ap-south-1.amazonaws.com/notification/";

export const connectionrequestsent ="https://mryf7ohthh.execute-api.ap-south-1.amazonaws.com/connectionrequestsent"
export const connectionrequestaccept ="https://u4hgdgu462.execute-api.ap-south-1.amazonaws.com/connectionrequestaccept"
export const pdfConverter ="https://5nrsw9myja.execute-api.ap-south-1.amazonaws.com/pdfConverterNew"
export const moodleToken = "ecef2b807ad2669e7e57b4104efb0217"
export const baseURL = window.location.origin
export const moodleAppBaseUrl = baseURL !== "https://www.mysphere.net" ? "https://devstemclip.mysphere.net/" : "https://stemclip.mysphere.net/";
export const moodleApiUrl = `${moodleAppBaseUrl}/webservice/rest/server.php`
export const assessmentBaseUrl =  baseURL !== "https://www.mysphere.net" ? "https://d3miq8k3kfqo5s.cloudfront.net" : "https://d3awjl27jexv21.cloudfront.net";
export const s3CloudFrontUrl = baseURL !== "https://www.mysphere.net" ? "https://dtmqd85q4ygtb.cloudfront.net" : "https://d35psbb0poemi8.cloudfront.net";
// export const s3CloudFrontUrl = "https://dtmqd85q4ygtb.cloudfront.net"
export const cloudfrontKeyPairId = "K3CCL7F81MS5XB";
export const appLink = baseURL === "https://www.mysphere.net" ? "https://www.mysphere.net/" : baseURL === "https://dev.mysphere.net" ? "https://dev.mysphere.net/" : "http://localhost:3000/";
export const mysphereAPIURL =  baseURL === "https://www.mysphere.net" ? "https://api.mysphere.net" : baseURL === "http://localhost:3000" ? "http://localhost:9000" : "https://apidev.mysphere.net";
export const googleClientId = baseURL === "https://www.mysphere.net" ? "512254333973-ms4l9tmop2ib85jhblvubg8e81ikcq78.apps.googleusercontent.com" : "240246132475-12d1bhnpo9btim7t5d9dkqmcjg9c1ef6.apps.googleusercontent.com";
export const googleClientSecret = baseURL === "https://www.mysphere.net" ? "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" : "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";
export const AIChatTypes = {
    SKILL_JOURNEY: "skill_journey",
    SELF_JOURNEY: "self_journey",
    PDF_ASSESSMENT: "pdf_assessment",
    ORG_COHORT_PDF_ASSESSMENT: "org_cohort_pdf_assessment",
}
export const QuestionTypes = {
    SINGLE_CHOICE_MCQ: "single_choice_mcq",
    SHORT_ANSWER: "short_answer",
}    
export const organizationTypes = {
    SCHOOL: "SCHOOL",
    COLLEGE: "COLLEGE",
    CORPORATE: "CORPORATE",
}
export const logoSize = 512;
